export const idTypeOptions = [
  {
    value: 'NZ_PASSPORT',
    label: 'New Zealand Passport',
  },
  {
    value: 'NZ_FIREARM_LICENCE',
    label: 'New Zealand Firearm Licence',
  },
  {
    value: 'AU_PASSPORT',
    label: 'Australian/Cook Islands/Tokelau/Niue Passport',
  },
  {
    value: 'OTHER_PASSPORT',
    label: 'Other Passport',
  },
];
